module.exports = __webpack_public_path__ + "static/media/icon-lock-white.bbb5e46d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-lock-white.svg
// module id = ./src/assets/images/icon-lock-white.svg
// module chunks = 6